"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _InputAddon = _interopRequireDefault(require("./InputAddon"));

var _TextInput = _interopRequireDefault(require("./TextInput"));

var _CheckMarkIcon = _interopRequireDefault(require("../Icons/CheckMarkIcon"));

var _MagGlassIcon = _interopRequireDefault(require("../Icons/MagGlassIcon"));

var _StatusIcon = _interopRequireDefault(require("../Badge/StatusIcon"));

var _Loader = _interopRequireDefault(require("../Loader/Loader"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// Prebuild preffix loading states.
var BUILT_IN_SUFFIX = {
  LOADING: 'loading',
  SUCCESS: 'success',
  FAILED: 'failed'
};
/**
 * Text input component.
 * NOTE: Aside from the documented properties, all valid dom input props can
 * be used.
 */

var Input =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Input).call(this, props));

    _this.handleInputFocus = function (event) {
      var onFocus = _this.props.onFocus;

      _this.setState({
        isFocus: true
      });

      if (onFocus) {
        onFocus(event);
      }
    };

    _this.handleInputBlur = function (event) {
      var onBlur = _this.props.onBlur;

      _this.setState({
        isFocus: false
      });

      if (onBlur) {
        onBlur(event);
      }
    };

    _this.state = {
      // This is used to ensure proper styling for the prefix and suffix
      // when TextInput is in focus.
      isFocus: false
    };
    _this.inputRef = props.inputRef || _react.default.createRef();
    return _this;
  }
  /**
   * Handler for when input receives focus.
   * @param {ReactEvent} event - React event of the input dom element.
   */


  _createClass(Input, [{
    key: "getInputAddon",

    /**
     * Create the InputAddon element with the given props.
     * @param {object} props - input addon props
     * @param {ReactElement} content - content goes inside the addon
     * @returns {ReactElement} - react element.
     */
    value: function getInputAddon(props, content) {
      return _react.default.createElement(_InputAddon.default, props, content);
    }
    /**
     * Render prefix, suffix, addonBefore and addonAfter element.
     * @param {string} type: one of 'prefix', 'suffix', 'addonBefore', 'addonAfter'
     * @returns {ReactElement| undefined} - React element.
     */

  }, {
    key: "renderAddonType",
    value: function renderAddonType(type) {
      var _this$props = this.props,
          appearance = _this$props.appearance,
          error = _this$props.error,
          disabled = _this$props.disabled,
          search = _this$props.search,
          builtInSuffix = _this$props.builtInSuffix;
      var addonTypeProps = {
        appearance: appearance,
        error: error,
        disabled: disabled,
        focus: this.state.isFocus,
        type: type
      };
      var addOn = this.props[type];
      var addOnProps = this.props["".concat(type, "Props")] || {};

      if (addOn) {
        return this.getInputAddon(_objectSpread({}, addonTypeProps, {}, addOnProps), addOn);
      } // Build in addon.


      if (search && type === _InputAddon.default.TYPE.PREFIX) {
        return this.getInputAddon(addonTypeProps, _react.default.createElement(_MagGlassIcon.default, {
          color: _ThemeManager.default.getVar('gray-2')
        }));
      }

      if (type === _InputAddon.default.TYPE.SUFFIX) {
        switch (builtInSuffix.type) {
          case BUILT_IN_SUFFIX.LOADING:
            return this.getInputAddon(addonTypeProps, _react.default.createElement(_Loader.default, null));

          case BUILT_IN_SUFFIX.SUCCESS:
            return this.getInputAddon(addonTypeProps, _react.default.createElement(_CheckMarkIcon.default, {
              color: _ThemeManager.default.getVar('green-1')
            }));

          case BUILT_IN_SUFFIX.FAILED:
            return this.getInputAddon(addonTypeProps, _react.default.createElement(_StatusIcon.default, {
              type: _StatusIcon.default.STATUS_ICON_TYPES.ALERT,
              tooltipProps: {
                content: builtInSuffix.failMessage
              }
            }));

          default:
            break;
        }
      }
    }
    /**
     * Render the input component.
     * @returns {ReactElement} - React node.
     */

  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this2 = this;

      // eslint-disable-next-line no-unused-vars
      var _this$props2 = this.props,
          search = _this$props2.search,
          suffix = _this$props2.suffix,
          prefix = _this$props2.prefix,
          builtInSuffix = _this$props2.builtInSuffix,
          addonBeforeProps = _this$props2.addonBeforeProps,
          addonAfterProps = _this$props2.addonAfterProps,
          wrapperProps = _this$props2.wrapperProps,
          appearance = _this$props2.appearance,
          addonBefore = _this$props2.addonBefore,
          addonAfter = _this$props2.addonAfter,
          textInputProps = _objectWithoutProperties(_this$props2, ["search", "suffix", "prefix", "builtInSuffix", "addonBeforeProps", "addonAfterProps", "wrapperProps", "appearance", "addonBefore", "addonAfter"]);

      var suffixNode = this.renderAddonType(_InputAddon.default.TYPE.SUFFIX);
      var prefixNode = this.renderAddonType(_InputAddon.default.TYPE.PREFIX);
      var addonBeforeNode = this.renderAddonType(_InputAddon.default.TYPE.ADDON_BEFORE);
      var addonAfterNode = this.renderAddonType(_InputAddon.default.TYPE.ADDON_AFTER);
      return _react.default.createElement(_FlexLayout.default, {
        display: "inline-flex",
        alignItems: "center",
        itemSpacing: "0px"
      }, addonBeforeNode, _react.default.createElement(_FlexLayout.default, {
        className: "text-input-wrapper",
        display: "inline-flex",
        alignItems: "center",
        itemSpacing: "0px",
        "data-addon-after": !!addonAfter,
        onClick: function onClick() {
          return _this2.inputRef.current.focus();
        }
      }, prefixNode, _react.default.createElement(_TextInput.default, _extends({}, textInputProps, {
        addonBefore: !!addonBefore,
        addonAfter: !!addonAfter,
        prefix: !!prefixNode,
        suffix: !!suffixNode,
        onFocus: this.handleInputFocus,
        onBlur: this.handleInputBlur,
        inputRef: this.inputRef,
        appearance: appearance
      })), suffixNode), addonAfterNode);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          wrapperProps = _this$props3.wrapperProps;
      return _react.default.createElement(_FlexLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-input")),
        flexDirection: "column",
        itemSpacing: "10px"
      }, wrapperProps), this.renderInput());
    }
  }]);

  return Input;
}(_react.default.Component);

exports.default = Input;
Input.BUILT_IN_SUFFIX = BUILT_IN_SUFFIX;
Input.defaultProps = {
  error: false,
  disabled: false,
  search: false,
  builtInSuffix: {},
  addonBeforeProps: {},
  addonAfterProps: {}
};
Input.propTypes = {
  /**
   * Custom class name.  This name will appear on both the upper Input
   * component wrapper and the dom input.
   */
  className: _propTypes.default.string,

  /**
   * Callback when input received focus.
   * onFocus(event)
   * {ReactEvent} event: the input dom react event.
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback when input loss focus.
   * onFocus(event)
   * {ReactEvent} event: the input dom react event.
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback when enter key is pressed
   * onPressEnter(event)
   * {ReactEvent} event - This is the input ReactEvent.
   */
  onPressEnter: _propTypes.default.func,

  /**
   * Input appearance style<br>
   * 'inline' - Input is inline and nested with no borders or background.
   * 'normal' - border with focus highlight<br>
   * 'borderless' - no border with focus highlight.  Normally used on darker contrasted background.<br>
   * 'nested' - no border with no focus highlight.
   *    Useful around situation where you need input inside another component.
   *    For example input inside a table cell.
   */
  appearance: _propTypes.default.oneOf(['inline', 'normal', 'borderless', 'nested']),

  /**
   * Error styling.  The input is highlighted in red.
   */
  error: _propTypes.default.bool,

  /**
   * To disable the input.
   */
  disabled: _propTypes.default.bool,

  /**
   * To add a suffix element.  See example on the usage.
   */
  suffix: _propTypes.default.node,

  /**
   * To add a prefix element. See example on the usage.
   */
  prefix: _propTypes.default.node,

  /**
   * If true input will prefix with a search icon style. NOTE: If you also
   * pass in prefix then this will be ignored.
   */
  search: _propTypes.default.bool,

  /**
   * Attach an element before the input.  If prefix is used this element will
   * go before the prefix.
   */
  addonBefore: _propTypes.default.node,

  /**
   * Additional dom properties passes on to the addOnBefore wrapper element.
   */
  addonBeforeProps: _propTypes.default.object,

  /**
   * Attach an element after the input.  If suffix is used this element will
   * go after the suffix.
   */
  addonAfter: _propTypes.default.node,

  /**
   * Additional dom properties passes on to the addonAfter wrapper element.
   */
  addonAfterProps: _propTypes.default.object,

  /**
   * default value for the input.  This is a bit different than props.value
   * in that this doesn't require application to handle onChange.
   */
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * The input value.  If an application supply this then the application
   * also need to handle onChange.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Callback to handle input value change.
   */
  onChange: _propTypes.default.func,

  /**
   * Predefined suffix styling.  If this is used props.suffix will be
   * ignored.
   */
  builtInSuffix: _propTypes.default.shape({
    /**
     * One of the following type:<br>
     * 'loading' : Add a suffix Loader spinner.<br>
     * 'success' : Add a suffix green check mark.<br>
     * 'failed' : Add a suffix failed status indicator. NOTE: You should
     * also provide builtInSuffix.failMessage
     */
    type: _propTypes.default.oneOf([BUILT_IN_SUFFIX.LOADING, BUILT_IN_SUFFIX.SUCCESS, BUILT_IN_SUFFIX.FAILED]),

    /**
     * This is required if you specify type.failed.
     */
    failMessage: _propTypes.default.string
  }),

  /**
   * This provides a way for you to get a reference to the `<input>` dom node.
   * It can be a callback function or an object from React.createRef().
   */
  inputRef: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),

  /**
   * Addition dom attributes to be added to the top level wrapping dom element.
   */
  wrapperProps: _propTypes.default.object
};